import { AnalyticsFilterSection } from '../../widgets/analytics/analyticsFilterSection';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';

// Страница отображения выбора фильтров для составления сводного отчёта
export function AnalyticsPage() {

    return (
        <div className="analytics-page-div">
            <ContentHeader title="Параметры отчёта" />
            <AnalyticsFilterSection />
        </div>
    );
}

